// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"0e2e1217","432":"c8d1a647","507":"30d8ff43","767":"a9ea1bb0","880":"8486d849"}[chunkId] + ".chunk.js";
};